var map = {
	"./common/audio/bg.mp3": "TshJ",
	"./common/audio/bg.ogg": "aPr9",
	"./common/audio/bg.wav": "GENn",
	"./common/audio/hero-cv-1.mp3": "Rtzf",
	"./common/audio/hero-cv-1.ogg": "mmVA",
	"./common/audio/hero-cv-1.wav": "zilZ",
	"./common/audio/hero-cv-2.mp3": "fN2G",
	"./common/audio/hero-cv-2.ogg": "5WsH",
	"./common/audio/hero-cv-2.wav": "X0xQ",
	"./common/audio/hero-cv-3.mp3": "ZTLm",
	"./common/audio/hero-cv-3.ogg": "aRj2",
	"./common/audio/hero-cv-3.wav": "uATz",
	"./common/audio/hero-cv-4.mp3": "1Gso",
	"./common/audio/hero-cv-4.ogg": "irzU",
	"./common/audio/hero-cv-4.wav": "10ev",
	"./common/audio/hero-cv-5.mp3": "pcny",
	"./common/audio/hero-cv-5.ogg": "VpjS",
	"./common/audio/hero-cv-5.wav": "sjhT",
	"./common/audio/hero-cv-6.mp3": "8ZLL",
	"./common/audio/hero-cv-6.ogg": "mRGU",
	"./common/audio/hero-cv-6.wav": "QsYI",
	"./common/audio/hero-cv-7.mp3": "EQht",
	"./common/audio/hero-cv-7.ogg": "ddCI",
	"./common/audio/hero-cv-7.wav": "yljO",
	"./common/audio/hero-cv-8.mp3": "rD2I",
	"./common/audio/hero-cv-8.ogg": "C6Ih",
	"./common/audio/hero-cv-8.wav": "XMEO",
	"./common/audio/noplay.png": "3MBF",
	"./common/audio/play.png": "RTHZ",
	"./common/game-rating.jpeg": "uHnm",
	"./common/h5/imgs/bg-1-hero.png": "q8Am",
	"./common/h5/imgs/bg-1.jpg": "qOcM",
	"./common/h5/imgs/bg-2-hero.png": "dAOT",
	"./common/h5/imgs/bg-2.jpg": "NA/H",
	"./common/h5/imgs/bg-3.jpg": "1nPs",
	"./common/h5/imgs/bg-4.jpg": "teTo",
	"./common/h5/imgs/bg-5.jpg": "IW9i",
	"./common/h5/imgs/bg-bottom.png": "xf9z",
	"./common/h5/imgs/bg-top-tool.png": "Mh9M",
	"./common/h5/imgs/btn-menu.png": "d4T3",
	"./common/h5/imgs/feature-navigation.png": "1p9z",
	"./common/h5/imgs/hero-1.png": "AlYW",
	"./common/h5/imgs/hero-2.png": "UnMJ",
	"./common/h5/imgs/hero-3.png": "qX8I",
	"./common/h5/imgs/hero-4.png": "CJq1",
	"./common/h5/imgs/hero-5.png": "kMYb",
	"./common/h5/imgs/hero-6.png": "TwcY",
	"./common/h5/imgs/hero-7.png": "ymI4",
	"./common/h5/imgs/hero-8.png": "JhbH",
	"./common/h5/imgs/menu-close.png": "fXTp",
	"./common/h5/imgs/menu-line.png": "6mps",
	"./common/h5/imgs/section-next.png": "I/Be",
	"./common/pc/imgs/baha.png": "/AQJ",
	"./common/pc/imgs/bg-2.jpg": "em/3",
	"./common/pc/imgs/bg-3.jpg": "FQ6X",
	"./common/pc/imgs/bg-4.jpg": "1JK3",
	"./common/pc/imgs/bg-5.jpg": "Cc0D",
	"./common/pc/imgs/bg-lang.png": "ycuO",
	"./common/pc/imgs/bg-option.png": "T1xh",
	"./common/pc/imgs/facebook.png": "Mi2w",
	"./common/pc/imgs/feature-navigation.png": "u6xz",
	"./common/pc/imgs/hero-1.png": "RJm1",
	"./common/pc/imgs/hero-2.png": "Z2Wm",
	"./common/pc/imgs/hero-3.png": "pKQQ",
	"./common/pc/imgs/hero-4.png": "YGbZ",
	"./common/pc/imgs/hero-5.png": "7zno",
	"./common/pc/imgs/hero-6.png": "1zrG",
	"./common/pc/imgs/hero-7.png": "M3p2",
	"./common/pc/imgs/hero-8.png": "KAr3",
	"./common/pc/imgs/hero-navigation.png": "/7FM",
	"./common/pc/imgs/lang-tw.png": "nxDU",
	"./common/pc/imgs/lang-zh.png": "dpj/",
	"./common/pc/imgs/play-btn.png": "+/OH",
	"./common/pc/imgs/vedio-bg-1.png": "9wL0",
	"./common/pc/vedio/bg-1.webm": "Y7CA",
	"./common/pc/vedio/首页组简体.webm": "TN7k",
	"./common/pc/vedio/首页组繁体.webm": "FHPt",
	"./common/vedio/game.mp4": "Jsi6",
	"./tw/h5/imgs/achieved.png": "6OWO",
	"./tw/h5/imgs/bg-1-info.png": "FidO",
	"./tw/h5/imgs/bg-1-logo.png": "0rBB",
	"./tw/h5/imgs/bg-worldview.png": "D4Iv",
	"./tw/h5/imgs/feature-1.jpg": "r/7X",
	"./tw/h5/imgs/feature-2.jpg": "w1Xe",
	"./tw/h5/imgs/feature-3.jpg": "td0+",
	"./tw/h5/imgs/feature-4.jpg": "AoOB",
	"./tw/h5/imgs/feature-5.jpg": "wiR1",
	"./tw/h5/imgs/game-feature.png": "wff5",
	"./tw/h5/imgs/game-logo.png": "HADW",
	"./tw/h5/imgs/hero-cv-1.png": "3qMq",
	"./tw/h5/imgs/hero-cv-2.png": "aGYt",
	"./tw/h5/imgs/hero-cv-3.png": "KOl/",
	"./tw/h5/imgs/hero-cv-4.png": "EaK8",
	"./tw/h5/imgs/hero-cv-5.png": "8N6+",
	"./tw/h5/imgs/hero-cv-6.png": "k/aH",
	"./tw/h5/imgs/hero-cv-7.png": "yiUi",
	"./tw/h5/imgs/hero-cv-8.png": "OxBp",
	"./tw/h5/imgs/hero-info-1.png": "UejY",
	"./tw/h5/imgs/hero-info-2.png": "VLIn",
	"./tw/h5/imgs/hero-info-3.png": "J/zX",
	"./tw/h5/imgs/hero-info-4.png": "01HS",
	"./tw/h5/imgs/hero-info-5.png": "qBFl",
	"./tw/h5/imgs/hero-info-6.png": "7yEH",
	"./tw/h5/imgs/hero-info-7.png": "GfKH",
	"./tw/h5/imgs/hero-info-8.png": "thGx",
	"./tw/h5/imgs/hero-logo.png": "/f2z",
	"./tw/h5/imgs/menu-1.png": "MHXC",
	"./tw/h5/imgs/menu-2.png": "evQN",
	"./tw/h5/imgs/menu-3.png": "WvxE",
	"./tw/h5/imgs/menu-4.png": "uV73",
	"./tw/h5/imgs/menu-5.png": "9Rw9",
	"./tw/h5/imgs/reward.png": "JX9R",
	"./tw/h5/imgs/top-btn.png": "RD3t",
	"./tw/h5/imgs/worldview-text.png": "l7Ti",
	"./tw/pc/imgs/achieved.png": "Orfg",
	"./tw/pc/imgs/android-btn.png": "vH/b",
	"./tw/pc/imgs/bg-1-logo.png": "w7X3",
	"./tw/pc/imgs/bg-1.jpg": "ZiwU",
	"./tw/pc/imgs/bg-worldview.png": "KXnT",
	"./tw/pc/imgs/feature-1.jpg": "xyW+",
	"./tw/pc/imgs/feature-2.jpg": "v6fQ",
	"./tw/pc/imgs/feature-3.jpg": "6vJB",
	"./tw/pc/imgs/feature-4.jpg": "SsIZ",
	"./tw/pc/imgs/feature-5.jpg": "16pB",
	"./tw/pc/imgs/game-feature.png": "jm5d",
	"./tw/pc/imgs/hero-cv-1.png": "pNtq",
	"./tw/pc/imgs/hero-cv-2.png": "uuvz",
	"./tw/pc/imgs/hero-cv-3.png": "Hpyy",
	"./tw/pc/imgs/hero-cv-4.png": "xn1A",
	"./tw/pc/imgs/hero-cv-5.png": "aPm/",
	"./tw/pc/imgs/hero-cv-6.png": "yda2",
	"./tw/pc/imgs/hero-cv-7.png": "9hql",
	"./tw/pc/imgs/hero-cv-8.png": "MpZK",
	"./tw/pc/imgs/hero-info-1.png": "Sgpw",
	"./tw/pc/imgs/hero-info-2.png": "iCDg",
	"./tw/pc/imgs/hero-info-3.png": "s8p/",
	"./tw/pc/imgs/hero-info-4.png": "Bmjq",
	"./tw/pc/imgs/hero-info-5.png": "Xk/T",
	"./tw/pc/imgs/hero-info-6.png": "8HdQ",
	"./tw/pc/imgs/hero-info-7.png": "oPZS",
	"./tw/pc/imgs/hero-info-8.png": "24Pb",
	"./tw/pc/imgs/ios-btn.png": "p/EF",
	"./tw/pc/imgs/menu-1.png": "2Ms7",
	"./tw/pc/imgs/menu-2.png": "vn3o",
	"./tw/pc/imgs/menu-3.png": "L6Yj",
	"./tw/pc/imgs/menu-4.png": "yw7w",
	"./tw/pc/imgs/menu-5.png": "tywX",
	"./tw/pc/imgs/menu.png": "xe73",
	"./tw/pc/imgs/reward.png": "YQXe",
	"./tw/pc/imgs/worldview-text.png": "GMIs",
	"./tw/pc/vedio/bg-1.webm": "ymwL",
	"./zh/h5/imgs/achieved.png": "RrKk",
	"./zh/h5/imgs/bg-1-info.png": "G4bo",
	"./zh/h5/imgs/bg-1-logo.png": "P5SN",
	"./zh/h5/imgs/bg-worldview.png": "dhma",
	"./zh/h5/imgs/feature-1.jpg": "c/RQ",
	"./zh/h5/imgs/feature-2.jpg": "d3n+",
	"./zh/h5/imgs/feature-3.jpg": "BPEA",
	"./zh/h5/imgs/feature-4.jpg": "o+eR",
	"./zh/h5/imgs/feature-5.jpg": "tej0",
	"./zh/h5/imgs/game-feature.png": "3OV0",
	"./zh/h5/imgs/game-logo.png": "/8es",
	"./zh/h5/imgs/hero-cv-1.png": "8Vfu",
	"./zh/h5/imgs/hero-cv-2.png": "/4hE",
	"./zh/h5/imgs/hero-cv-3.png": "ZF+X",
	"./zh/h5/imgs/hero-cv-4.png": "PGuA",
	"./zh/h5/imgs/hero-cv-5.png": "jcLG",
	"./zh/h5/imgs/hero-cv-6.png": "OnuX",
	"./zh/h5/imgs/hero-cv-7.png": "V2gW",
	"./zh/h5/imgs/hero-cv-8.png": "6hyy",
	"./zh/h5/imgs/hero-info-1.png": "4T7U",
	"./zh/h5/imgs/hero-info-2.png": "xkSS",
	"./zh/h5/imgs/hero-info-3.png": "T7yg",
	"./zh/h5/imgs/hero-info-4.png": "TK4N",
	"./zh/h5/imgs/hero-info-5.png": "qQ/8",
	"./zh/h5/imgs/hero-info-6.png": "LiS/",
	"./zh/h5/imgs/hero-info-7.png": "eWDE",
	"./zh/h5/imgs/hero-info-8.png": "7DZq",
	"./zh/h5/imgs/hero-logo.png": "pk9v",
	"./zh/h5/imgs/menu-1.png": "lRUE",
	"./zh/h5/imgs/menu-2.png": "WkMq",
	"./zh/h5/imgs/menu-3.png": "rbQZ",
	"./zh/h5/imgs/menu-4.png": "moCW",
	"./zh/h5/imgs/menu-5.png": "xMrH",
	"./zh/h5/imgs/reward.png": "41X3",
	"./zh/h5/imgs/top-btn.png": "URp1",
	"./zh/h5/imgs/worldview-text.png": "uB5o",
	"./zh/pc/imgs/achieved.png": "0Pkh",
	"./zh/pc/imgs/android-btn.png": "fAwM",
	"./zh/pc/imgs/bg-1-logo.png": "LPb2",
	"./zh/pc/imgs/bg-1.jpg": "xzlA",
	"./zh/pc/imgs/bg-worldview.png": "5rzI",
	"./zh/pc/imgs/feature-1.jpg": "rTNG",
	"./zh/pc/imgs/feature-2.jpg": "AFQP",
	"./zh/pc/imgs/feature-3.jpg": "GeUg",
	"./zh/pc/imgs/feature-4.jpg": "pm9W",
	"./zh/pc/imgs/feature-5.jpg": "4kEJ",
	"./zh/pc/imgs/game-feature.png": "lZLR",
	"./zh/pc/imgs/hero-cv-1.png": "MsXH",
	"./zh/pc/imgs/hero-cv-2.png": "W1MS",
	"./zh/pc/imgs/hero-cv-3.png": "uO1b",
	"./zh/pc/imgs/hero-cv-4.png": "Rq8G",
	"./zh/pc/imgs/hero-cv-5.png": "5ZkH",
	"./zh/pc/imgs/hero-cv-6.png": "/7t4",
	"./zh/pc/imgs/hero-cv-7.png": "Rud7",
	"./zh/pc/imgs/hero-cv-8.png": "nXnx",
	"./zh/pc/imgs/hero-info-1.png": "auC7",
	"./zh/pc/imgs/hero-info-2.png": "DPEQ",
	"./zh/pc/imgs/hero-info-3.png": "xYK1",
	"./zh/pc/imgs/hero-info-4.png": "SuHp",
	"./zh/pc/imgs/hero-info-5.png": "XJxh",
	"./zh/pc/imgs/hero-info-6.png": "s2kx",
	"./zh/pc/imgs/hero-info-7.png": "uXpx",
	"./zh/pc/imgs/hero-info-8.png": "xZUN",
	"./zh/pc/imgs/ios-btn.png": "GRlb",
	"./zh/pc/imgs/menu-1.png": "KsSb",
	"./zh/pc/imgs/menu-2.png": "IzCT",
	"./zh/pc/imgs/menu-3.png": "0EEn",
	"./zh/pc/imgs/menu-4.png": "QulH",
	"./zh/pc/imgs/menu-5.png": "DcYL",
	"./zh/pc/imgs/menu.png": "1p5s",
	"./zh/pc/imgs/reward.png": "mm7l",
	"./zh/pc/imgs/worldview-text.png": "1tc+",
	"./zh/pc/vedio/bg-1.webm": "CtQd"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "GoKW";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web-firehero ^\.\/.*$
// module id = GoKW
// module chunks = 13